import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { getSiteContent } from '#api';
import defaultSiteContent from '../../utils/siteContentDefaults';

const Footer = () => {
    const [siteContent, setSiteContent] = useState(defaultSiteContent);

    useEffect(() => {
        const loadSiteContent = async () => {
            try {
                const response = await getSiteContent();
                if (response.data?.footer) {
                    setSiteContent(response.data);
                }
            } catch (error) {
                console.error('Error loading footer content:', error);
            }
        };

        loadSiteContent();
    }, []);

    const footer = siteContent?.footer || defaultSiteContent.footer;
    const socialLinks = footer.social || defaultSiteContent.footer.social;

    return (
        <footer className="anikino__footer">
            <div className="anikino__footer-content">
                <div className="anikino__footer-section hours">
                    <h2>Godziny Otwarcia</h2>
                    <ul>
                        {(footer.hours || []).map((entry, index) => (
                            <li key={`${entry.label}-${index}`}>
                                {entry.label} <br /> {entry.value}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="anikino__footer-section contact">
                    <h2>Kontakt</h2>
                    <ul>
                        {(footer.contact || []).map((entry, index) => (
                            <li key={`${entry.label}-${index}`}>
                                {entry.label ? `${entry.label}: ` : ''}
                                {entry.value}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="anikino__footer-section media">
                    <h2>Wpadnij na nasze media!</h2>
                    <div className="media-list">
                        {socialLinks.facebook ? (
                            <a
                                href={socialLinks.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaFacebook />
                            </a>
                        ) : null}
                        {socialLinks.instagram ? (
                            <a
                                href={socialLinks.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaInstagram />
                            </a>
                        ) : null}
                        {socialLinks.tiktok ? (
                            <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer">
                                <FaTiktok />
                            </a>
                        ) : null}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
